import React, { useState } from "react";
import "./masterclass.css"; // Move the `<style>` content into this CSS file
import { FaRegClock } from "react-icons/fa";
import axios from "axios";
import { Helmet } from "react-helmet";

function Masterclass() {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    testType: "",
    preferredDays: [],
    previousTest: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [Error, setError] = useState("");
  const [Loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        preferredDays: checked
          ? [...prev.preferredDays, value]
          : prev.preferredDays.filter((day) => day !== value),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  async function Get_Country() {
    let Country = "";

    const response = await fetch("https://ipjson.searcheducation.in/getip");
    const IpData = await response.json();

    let res = await fetch(`https://ipapi.co/${IpData.ip}/json`);
    let CountryData = await res.json();

    Country = CountryData?.country_name;
    // console.log(CountryData);
    return CountryData?.country_name;
  }

  const handlePost = async () => {
    try {
      var Api = "https://api.searcheducation.in/lp/contact/event/masterclass";
      let Name = formData.fullName;
      let email = formData.email;
      // let city = formData.value;
      let phone = formData.phone;
      let country = await Get_Country();
      let url = window.location.href;

      let Comments = `<table>
<tr>
<td>Test Type: </td>
<td>${formData?.testType}</td>
</tr>
<tr>
<td>Taken test Before: </td>
<td>${formData?.previousTest}</td>
</tr>
<tr>
<td>Preferred Days: </td>
<td>${formData?.preferredDays?.join(",")}</td>
</tr>

</table>`;
      const { data } = await axios.post(
        Api,
        {
          name: Name,
          email,
          phone,
          country,
          url,
          Category: "",
          SubCategory: "",
          Registered_By: 2,
          campaign: "120227054717680203",
          Contact_Platform: "TST",
          Comments,
        },
        { headers: { "Content-Type": "application/json" } }
      );
      console.log(data);
      setLoading(false);
      setSubmitted(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setError(
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message
      );
      setSubmitted(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    if (!formData.fullName || !formData.phone || !formData.email) {
      setError("Please fill in all required fields.");
      setLoading(false);
      return;
    }

    await handlePost();
  };

  if (submitted && !Error) {
    return (
      <div className="master_class">
        <div className="success-container">
          <div className="success-card">
            <div className="success-icon">
              <svg fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
              10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5
              1.41-1.41L10 14.17l7.59-7.59L19
              8l-9 9z"
                />
              </svg>
            </div>
            <h2 className="success-title">Registration Successful!</h2>
            <p className="success-message">
              Thank you for registering! We'll contact you soon with the venue
              details and additional information.
            </p>
            <div className="success-details">
              <p className="date">📅 23rd Aug, 2025 | Chandigarh</p>
              <p className="note">Check your phone/email for confirmation</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          IELTS & PTE Masterclass in Chandigarh – Free Workshop by Certified
          Trainer
        </title>
        <meta
          name="title"
          content="IELTS & PTE Masterclass in Chandigarh – Free Workshop by Certified Trainer"
        />
        <meta
          name="description"
          content="Join Testifyi’s Free IELTS & PTE Masterclass in Chandigarh. Learn examiner-approved strategies, practice live, and get a personalized score improvement plan. Limited seats – register now!"
        />
        <meta
          name="keywords"
          content="ielts masterclass chandigarh, pte masterclass chandigarh, free ielts workshop chandigarh, pte training chandigarh, ielts coaching chandigarh, pte coaching chandigarh, testifyi chandigarh"
        />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.testifyi.com/" />
        <meta
          property="og:title"
          content="Free IELTS & PTE Masterclass in Chandigarh & Delhi | Testifyi"
        />
        <meta
          property="og:description"
          content="Boost your IELTS & PTE scores with Testifyi’s FREE Masterclass in Delhi & Chandigarh. Learn from certified trainers, practice in real-time, and master proven strategies."
        />
        <meta
          property="og:image"
          content="https://www.testifyi.com/images/ielts-pte-masterclass.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.testifyi.com/" />
        <meta
          name="twitter:title"
          content="Free IELTS & PTE Masterclass in Chandigarh & Delhi | Testifyi"
        />
        <meta
          name="twitter:description"
          content="Join our FREE IELTS & PTE Masterclass. Learn proven tips, practice live, and improve your scores with Testifyi’s certified trainers in Delhi & Chandigarh."
        />
        <meta
          name="twitter:image"
          content="https://www.testifyi.com/assets/image/ielts-pte-master-class.png"
        />

        {/* Additional SEO Tags */}
        <link rel="canonical" href="https://www.testifyi.com/" />
        <meta name="author" content="Testifyi" />
      </Helmet>
      <div className="master_class">
        {/* Header Banner */}
        <div className="header-banner">
          <div className="container">
            <p>
              <span className="clock-icon">
                <FaRegClock />
              </span>
              Limited Seats Available - Register Now!
            </p>
          </div>
        </div>

        {/* Main Form */}
        <div className="main-content container content-grid">
          {/* Left Column */}
          <div className="left-column">
            {/* Hero Section */}
            <div className="hero-section">
              <h1 className="hero-title">
                Crack <span className="highlight-blue">IELTS/PTE</span> with
                Confidence
              </h1>
              <p className="hero-subtitle">
                Join Our{" "}
                <span className="highlight-green">FREE Masterclass</span> in
                Chandigarh!
              </p>
              <div className="date-badge">📅 23rd Aug | Saturday</div>
              {/* <div className="date-badge">📅 5th & 6th July | Saturday & Sunday</div> */}
            </div>

            {/* Trust Builder */}
            <div className="trust-builder">
              <p>
                Learn from an{" "}
                <span className="highlight-blue">IDP-certified expert</span>{" "}
                with{" "}
                <span className="highlight-green">15+ years of experience</span>{" "}
                &{" "}
                <span className="highlight-orange">
                  15,000+ students trained!
                </span>
              </p>
            </div>

            {/* Why Attend */}
            {/* <div className="why-attend">
            <h3>Why Attend This Masterclass?</h3>
            <div className="benefits-grid">
              {/* repeat similar benefit items
            </div>
          </div> */}

            <div className="why-attend">
              <h3>Why Attend This Masterclass?</h3>
              <div className="benefits-grid">
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <svg fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
                    </svg>
                  </div>
                  <span className="benefit-text">
                    2-Day FREE Classroom Training
                  </span>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <svg fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                  </div>
                  <span className="benefit-text">
                    Myths Busted & Real Strategies Shared
                  </span>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <svg fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                  </div>
                  <span className="benefit-text">7+ Band Score Planning</span>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <svg fill="currentColor" viewBox="0 0 24 24">
                      <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A2.996 2.996 0 0 0 17.06 7c-.8 0-1.54.37-2.01.97l-2.05 2.58c-.26.33-.26.8 0 1.13l2.05 2.58c.47.6 1.21.97 2.01.97.83 0 1.58-.34 2.12-.89L21 22h-1zm-6.5-10.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S12 9.17 12 10s.67 1.5 1.5 1.5zM5.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm1.5 1H5c-.83 0-1.58.34-2.12.89L1 10.5 2 11l1.5-1.5c.39-.39 1.02-.39 1.41 0L6.5 11 7 10.5 5.38 7.89C5.84 7.34 6.58 7 7 7z" />
                    </svg>
                  </div>
                  <span className="benefit-text">
                    Personalised Speaking/Writing Tips
                  </span>
                </div>
                {/* <div className="benefit-item">
                                    <div className="benefit-icon">
                                        <svg fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                        </svg>
                                    </div>
                                    <span className="benefit-text">Certificate of Participation</span>
                                </div> */}
                {/*<div className="benefit-item">
                                    <div className="benefit-icon">
                                        <svg fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 6L12 10.5 8.5 8 12 5.5 15.5 8zM12 13.5l3.5 2.5L12 18.5 8.5 16l3.5-2.5z"/>
                                        </svg>
                                    </div>
                                    <span className="benefit-text">Live Mock Test Sessions</span>
                                </div>
                                <div className="benefit-item">
                                    <div className="benefit-icon">
                                        <svg fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                        </svg>
                                    </div>
                                    <span className="benefit-text">Score Improvement Techniques</span>
                                </div>
                                <div className="benefit-item">
                                    <div className="benefit-icon">
                                        <svg fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"/>
                                        </svg>
                                    </div>
                                    <span className="benefit-text">Time Management Strategies</span>
                                </div>
                                <div className="benefit-item">
                                    <div className="benefit-icon">
                                        <svg fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                                        </svg>
                                    </div>
                                    <span className="benefit-text">Study Materials & Resources</span>
                                </div>
                                <div className="benefit-item">
                                    <div className="benefit-icon">
                                        <svg fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                                        </svg>
                                    </div>
                                    <span className="benefit-text">Post-Session Email Support</span>
                                </div>
                                <div className="benefit-item">
                                    <div className="benefit-icon">
                                        <svg fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
                                        </svg>
                                    </div>
                                    <span className="benefit-text">Success Stories & Case Studies</span>
                                </div>
                                <div className="benefit-item">
                                    <div className="benefit-icon">
                                        <svg fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                        </svg>
                                    </div>
                                    <span className="benefit-text">Common Mistakes to Avoid</span>
                                </div>*/}
              </div>
            </div>

            {/* Trust Badges */}
            {/* <div className="trust-badges">
            <div className="badges-grid">
              <div className="badge-item">
                <div className="badge-number blue">15+</div>
                <div className="badge-text blue">Years Experience</div>
              </div>
              <div className="badge-item">
                <div className="badge-number green">15,000+</div>
                <div className="badge-text green">Students Trained</div>
              </div>
              <div className="badge-item">
                <div className="badge-number orange">IDP</div>
                <div className="badge-text orange">Certified Expert</div>
              </div>
            </div>
          </div> */}
          </div>

          {/* Right Column — Form */}
          <div className="form-container">
            <div className="form-card">
              <div className="form-header">
                <h2>Reserve Your Free Spot</h2>
                <p>Fill the details below to secure your seat</p>
              </div>
              <form disabled={Loading} onSubmit={handleSubmit}>
                {/* Full Name */}
                <div className="form-group">
                  <label className="form-label">
                    {/* SVG icon */}
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    className="form-input input1"
                    placeholder="Enter your full name"
                    required
                    value={formData.fullName}
                    onChange={handleChange}
                  />
                </div>

                {/* Phone */}
                <div className="form-group">
                  <label className="form-label">
                    {/* SVG icon */}
                    Phone Number (WhatsApp preferred) *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-input input1"
                    placeholder="Enter your WhatsApp number"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                {/* Email */}
                <div className="form-group">
                  <label className="form-label">
                    {/* SVG icon */}
                    Email ID
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-input input1"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                {/* Test Type */}
                <div className="form-group">
                  <label className="form-label">
                    Which test are you preparing for?
                  </label>
                  <select
                    name="testType"
                    className="form-input"
                    value={formData.testType}
                    onChange={handleChange}
                  >
                    <option value="">Select your test</option>
                    <option value="IELTS">IELTS</option>
                    <option value="PTE">PTE</option>
                    <option value="Not sure">Not sure</option>
                  </select>
                </div>

                {/* Preferred Days */}
                <div className="form-group">
                  <label className="form-label">
                    Preferred Session Day (Select all that apply)
                  </label>
                  <div className="checkbox-group">
                    {[
                      "(IELTS/PTE) 23rd Aug (Saturday)",
                      // "(PTE) 23rd Aug (Sunday)",
                    ].map((day) => (
                      <label className="checkbox-item" key={day}>
                        <input
                          type="checkbox"
                          name="preferredDays"
                          value={day}
                          checked={formData.preferredDays.includes(day)}
                          onChange={handleChange}
                        />
                        <span>{day}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Previous Test */}
                <div className="form-group">
                  <label className="form-label">
                    Have you taken the test before?
                  </label>
                  <div className="radio-group">
                    {["Yes", "No"].map((ans) => (
                      <label className="radio-item" key={ans}>
                        <input
                          type="radio"
                          name="previousTest"
                          value={ans}
                          checked={formData.previousTest === ans}
                          onChange={handleChange}
                        />
                        <span>{ans}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Submit Button */}
                <button type="submit" className="submit-btn">
                  {Loading ? "Loading..." : "🎯 Reserve My Free Spot Now"}
                </button>

                {/* Trust Line */}
                <div className="trust-line">
                  <svg /* shield icon */></svg>
                  <p>
                    Your information is 100% safe with us. We'll contact you
                    only regarding the masterclass.
                  </p>
                </div>
              </form>
            </div>
            {Error ? <p style={{ color: "red" }}>{Error}</p> : ""}
          </div>
        </div>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <p>
              © 2025 Testifyi IELTS/PTE Masterclass Chandigarh. All rights
              reserved.
            </p>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Masterclass;
